<template>
  <div class="editPage">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  setWorkerBillTitle,
  getWorkerBillTitle,
} from 'api/getPay';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      pageUrl: '/manage/getPay/writeOff/worker/setBill',
      formComponents: ['baseForm'],
      editParams: {
        type: 1,
      },
    };
  },
  methods: {
    detailApi: getWorkerBillTitle,
    editApi: setWorkerBillTitle,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
